import { Control } from "../Control.js";
import { resolveValue } from "../utils/ui-helpers.js";

export class Field extends Control {

    constructor(parent, options = {}) {

        super(parent, options);

        const {
            label = 'Field',
            control = [],
        } = options;

        this.label = label;
        this.control = control;

    }

    getLabel() { return resolveValue(this.label) };

    getControl() { return resolveValue(this.control) };

    _render(r, vm) {

        if (!this.isVisible())
            return null;

        const renderer = r;

        const label = this.getLabel() ?? 'Field';
        const css = this.getCss() ?? '';
        const control = this.getControl();
        const renderedControl = control ? control.render(renderer, vm) : null;

        return renderer.field({ css, label }, renderedControl);

    }

}